module.exports = __webpack_public_path__ + "img/video-bg.45cd9f0a.webp";